import { ScenarioOptimizationsActionTypes } from './constants';
import { PAGINATION_DEFAULT_VALUE } from '../../helpers/defaultValue';

export const INIT_STATE = {
    errorGetNoShipments: null,
    loadingNoShipments: false,
    noShipments: null,
    errorTopZone: null,
    loadingTopZone: false,
    topZone: null,
    errorTopWeight: null,
    loadingTopWeight: false,
    topWeight: null,
    errorGetBaseChargeAmount: null,
    loadingBaseChargeAmount: false,
    baseChargeAmount: null,
    errorGetAvgBaseChargeAmount: null,
    loadingAvgBaseChargeAmount: false,
    avgBaseChargeAmount: null,
    loading: false,
    error: null,
    analyticsRecords: null,
    pagination: PAGINATION_DEFAULT_VALUE,
    loadingComparisonRatesBaseChargeAmount: false,
    comparisonRatesBaseChargeAmount: null,
    errorComparisonRatesBaseChargeAmount: null,
    loadingComparisonRatesAvgBaseChargeAmount: false,
    comparisonRatesAvgBaseChargeAmount: null,
    errorComparisonRatesAvgBaseChargeAmount: null,
    loadingCountByWeightAndZone: false,
    countByWeightAndZone: null,
    errorCountByWeightAndZone: null,
    loadingComparisonAnalyticsReport: false,
    comparisonAnalyticsReport: null,
    errorComparisonAnalyticsReport: null,
};

type ScenarioOptimizationsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

//TODO: define data type for orders
type State = {
    errorGetNoShipments?: null,
    loadingNoShipments: Boolean,
    noShipments: any,
    errorTopZone?: null,
    loadingTopZone: Boolean,
    topZone: any,
    errorTopWeight?: null,
    loadingTopWeight: Boolean,
    topWeight: any,
    errorGetBaseChargeAmount?: null,
    loadingBaseChargeAmount: Boolean,
    baseChargeAmount: any,
    errorGetAvgBaseChargeAmount?: null,
    loadingAvgBaseChargeAmount: Boolean,
    avgBaseChargeAmount: any,
    loading: Boolean,
    error?: null,
    analyticsRecords: any,
    pagination: any,
    loadingComparisonRatesBaseChargeAmount: Boolean,
    comparisonRatesBaseChargeAmount: any,
    errorComparisonRatesBaseChargeAmount: any,
    loadingComparisonRatesAvgBaseChargeAmount: Boolean,
    comparisonRatesAvgBaseChargeAmount: any,
    errorComparisonRatesAvgBaseChargeAmount: any,
    loadingCountByWeightAndZone: Boolean,
    countByWeightAndZone: any,
    errorCountByWeightAndZone: any,
    loadingComparisonAnalyticsReport: Boolean,
    comparisonAnalyticsReport: any,
    errorComparisonAnalyticsReport: any,
};

const ScenarioOptimizations = (state: State = INIT_STATE, action: ScenarioOptimizationsAction): any => {
    switch (action.type) {
        case ScenarioOptimizationsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ScenarioOptimizationsActionTypes.GET_NO_SHIPMENTS_REQUEST: {
                    return { ...state, loadingNoShipments: false, noShipments: action.payload.data };
                }
                case ScenarioOptimizationsActionTypes.GET_TOP_ZONE_REQUEST: {
                    return { ...state, loadingTopZone: false, topZone: action.payload.data };
                }
                case ScenarioOptimizationsActionTypes.GET_TOP_WEIGHT_REQUEST: {
                    return { ...state, loadingTopWeight: false, topWeight: action.payload.data };
                }
                case ScenarioOptimizationsActionTypes.GET_BASE_CHARGE_AMOUNT_REQUEST: {
                    return { ...state, loadingBaseChargeAmount: false, baseChargeAmount: action.payload.data };
                }
                case ScenarioOptimizationsActionTypes.GET_AVG_BASE_CHARGE_AMOUNT_REQUEST: {
                    return { ...state, loadingAvgBaseChargeAmount: false, avgBaseChargeAmount: action.payload.data };
                }
                case ScenarioOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_RECORDS: {
                    return {
                        ...state,
                        loading: false,
                        analyticsRecords: action.payload.data.analyticsRecords,
                        pagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                case ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_BASE_CHARGE_AMOUNT: {
                    return { ...state, loadingComparisonRatesBaseChargeAmount: false, comparisonRatesBaseChargeAmount: action.payload.data, };
                }
                case ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_AVG_BASE_CHARGE_AMOUNT: {
                    return { ...state, loadingComparisonRatesAvgBaseChargeAmount: false, comparisonRatesAvgBaseChargeAmount: action.payload.data };
                }
                case ScenarioOptimizationsActionTypes.GET_COUNT_BY_WEIGHT_AND_ZONE: {
                    return { ...state, loadingCountByWeightAndZone: false, countByWeightAndZone: action.payload.data };
                }
                case ScenarioOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_REPORT: {
                    return { ...state, loadingComparisonAnalyticsReport: false, comparisonAnalyticsReport: action.payload.data };
                }
                default:
                    return { ...state, 
                        loadingNoShipments: false, 
                        loadingTopZone: false, 
                        loadingTopWeight: false, 
                        loadingBaseChargeAmount: false, 
                        loadingAvgBaseChargeAmount: false, 
                        loading: false, 
                        loadingComparisonRatesBaseChargeAmount: false, 
                        loadingComparisonRatesAvgBaseChargeAmount: false, 
                        loadingTotalCostByWeightAndZone: false, 
                        loadingCountByWeightAndZone: false,
                        loadingComparisonAnalyticsReport: false };
            }

        case ScenarioOptimizationsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ScenarioOptimizationsActionTypes.GET_NO_SHIPMENTS_REQUEST: {
                    return { ...state, loadingNoShipments: false, errorGetNoShipments: action.payload.error };
                }
                case ScenarioOptimizationsActionTypes.GET_TOP_ZONE_REQUEST: {
                    return { ...state, loadingTopZone: false, errorTopZone: action.payload.error };
                }
                case ScenarioOptimizationsActionTypes.GET_TOP_WEIGHT_REQUEST: {
                    return { ...state, loadingTopWeight: false, errorTopWeight: action.payload.error };
                }
                case ScenarioOptimizationsActionTypes.GET_BASE_CHARGE_AMOUNT_REQUEST: {
                    return { ...state, loadingBaseChargeAmount: false, errorGetBaseChargeAmount: action.payload.error };
                }
                case ScenarioOptimizationsActionTypes.GET_AVG_BASE_CHARGE_AMOUNT_REQUEST: {
                    return { ...state, loadingAvgBaseChargeAmount: false, errorGetAvgBaseChargeAmount: action.payload.error };
                }
                case ScenarioOptimizationsActionTypes.GET_ALL_ANALYTICS_RECORDS: {
                    return { ...state, loading: false, error: action.payload.error };
                }
                case ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_BASE_CHARGE_AMOUNT: {
                    return { ...state, loadingComparisonRatesBaseChargeAmount: false, errorComparisonRatesBaseChargeAmount: action.payload.error };
                }
                case ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_AVG_BASE_CHARGE_AMOUNT: {
                    return { ...state, loadingComparisonRatesAvgBaseChargeAmount: false, errorComparisonRatesAvgBaseChargeAmount: action.payload.error };
                }
                case ScenarioOptimizationsActionTypes.GET_COUNT_BY_WEIGHT_AND_ZONE: {
                    return { ...state, loadingCountByWeightAndZone: false, errorCountByWeightAndZone: action.payload.error };
                }
                case ScenarioOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_REPORT: {
                    return { ...state, loadingComparisonAnalyticsReport: false, errorComparisonAnalyticsReport: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case ScenarioOptimizationsActionTypes.GET_NO_SHIPMENTS_REQUEST:
            return { ...state, loadingNoShipments: true, noShipments: null };
        case ScenarioOptimizationsActionTypes.GET_TOP_ZONE_REQUEST:
            return { ...state, loadingTopZone: true, topZone: null };
        case ScenarioOptimizationsActionTypes.GET_TOP_WEIGHT_REQUEST:
            return { ...state, loadingTopWeight: true, topWeight: null };
        case ScenarioOptimizationsActionTypes.GET_BASE_CHARGE_AMOUNT_REQUEST:
            return { ...state, loadingBaseChargeAmount: true, baseChargeAmount: null };
        case ScenarioOptimizationsActionTypes.GET_AVG_BASE_CHARGE_AMOUNT_REQUEST:
            return { ...state, loadingAvgBaseChargeAmount: true, avgBaseChargeAmount: null };
        case ScenarioOptimizationsActionTypes.GET_ALL_ANALYTICS_RECORDS:
            return { ...state, loading: true, analyticsRecords: null };
        case ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_BASE_CHARGE_AMOUNT:
            return { ...state, loadingComparisonRatesBaseChargeAmount: true, comparisonRatesBaseChargeAmount: null };
        case ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_AVG_BASE_CHARGE_AMOUNT:
            return { ...state, loadingComparisonRatesAvgBaseChargeAmount: true, comparisonRatesAvgBaseChargeAmount: null };
        case ScenarioOptimizationsActionTypes.GET_COUNT_BY_WEIGHT_AND_ZONE:
            return { ...state, loadingCountByWeightAndZone: true, countByWeightAndZone: null };
        case ScenarioOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_REPORT:
            return { ...state, loadingComparisonAnalyticsReport: true, comparisonAnalyticsReport: null };
        default:
            return { ...state };
    }
};

export default ScenarioOptimizations;
